import { Grid, Box, Typography } from "@mui/material"; // Import Box for using the sx prop on plain elements
// No need to explicitly import '@emotion/react' or '@emotion/styled' if you're just using MUI's sx prop

import myPortrait from "./assets/my-portrait.jpeg";

export default function PersonalGreeting() {
  return (
    <Grid
      container
      spacing={3}
      sx={{
        alignItems: "center",
        my: 4,
      }}
    >
      <Grid
        size={{
          xs: 12,
          md: 7,
        }}
      >
        <div>
          <Typography variant="h2" fontWeight={800} fontStyle={"bold"}>
            Hey there!&nbsp;👋🏻
          </Typography>
          <Typography variant="body1">
            My name is <b>Vladislavs Kirilovics</b>, I am a third year Computer
            Science student interested in software engineering. My main passion
            is development for mobile platforms, however I have proficiency in
            other fields as well. Right now I'm studying the following modules:
            Artificial Intelligence, Image Processing & Computer Vision -
            majors; Computational Neuroscience, Security Behaviours - minors,
            Advanced Computer Architecture - mini-project.
          </Typography>
        </div>
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 5,
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: {
                xs: "80%",
                sm: "60%",
                lg: "60%",
              },
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={myPortrait}
              alt="My portrait"
              style={{
                maxWidth: "100%",
                height: "auto",
                display: "block",
                borderRadius: "2rem",
              }}
            />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}
